import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=3e1ac304&"
import script from "./OrderEdit.vue?vue&type=script&lang=ts&"
export * from "./OrderEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports